import { SpanLoading } from '../fetch-status/span-loading';
import { Button, ButtonProps } from '../ui/button';
import { useAuth } from '@/client/hooks/use-auth';
import { forwardRef, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type AuthedButtonProps = ButtonProps & {
  showAuth?: boolean;
  showLoading?: boolean;
  isLoading?: boolean;
};
export const AuthedButton = forwardRef<HTMLButtonElement, AuthedButtonProps>(
  ({ showAuth = true, showLoading = true, onClick, children, disabled, onKeyUp, isLoading, ...props }, ref) => {
    const { t } = useTranslation();
    const { isAuthLoading, isAuthed, login } = useAuth();
    const handle = useMemo(() => (isAuthed ? onClick : login), [isAuthed, login, onClick]);
    const isDisabled = useMemo(
      () => isLoading || isAuthLoading || (disabled && isAuthed),
      [isLoading, isAuthLoading, disabled, isAuthed]
    );
    return (
      <Button
        type="button"
        {...props}
        disabled={isDisabled}
        ref={ref}
        onKeyUp={isAuthed ? onKeyUp : undefined}
        onClick={handle}
      >
        {showLoading && (isLoading || isAuthLoading) && <SpanLoading />}
        {showAuth && !isAuthed ? t('sign-in') : children}
      </Button>
    );
  }
);

AuthedButton.displayName = 'AuthedButton';
